export const getTabState = state => state.navigationTabs;
